

export async function fetchTransportDetails(id) {
  const res = await fetch(`${import.meta.env.VITE_BACKEND_URL}/api/shipments/${id}/details`);
  
  if (!res.ok) {
    throw new Error('Eroare la preluarea detaliilor transportului');
  }

  const data = await res.json();
  return data;
}
